function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{font-size:24px;font-family:var(--font-bold);font-weight:700;}"));

var _ref2 =
/*#__PURE__*/
React.createElement("title", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("text", {
  className: "cls-1",
  transform: "translate(63.04 25.13) rotate(-13.74)"
}, "\xD6"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(80.88 21.05) rotate(-0.93)"
}, "p"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(0.98, 0.21, -0.21, 0.98, 95.4, 20.85)"
}, "p"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(109.55 23.87) rotate(23.74)"
}, "n"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(121.8 29.14) rotate(35.42)"
}, "a"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(0.68, 0.74, -0.74, 0.68, 133.65, 37.49)"
}, "d"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(0.51, 0.86, -0.86, 0.51, 143.44, 48.17)"
}, "e"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(150.2 59.99) rotate(67.29)"
}), React.createElement("text", {
  className: "cls-1",
  transform: "translate(152.71 65.13) rotate(75.71)"
}, "B"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(156.21 78.93) rotate(87.37)"
}, "u"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(156.68 92.37) rotate(96.61)"
}, "t"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(155.59 101.18) rotate(102.71)"
}, "i"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(154.58 106.76) rotate(110.31)"
}, "k"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(150.81 117.42) rotate(120.4)"
}, "e"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(-0.64, 0.77, -0.77, -0.64, 143.79, 129.03)"
}, "r"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(113.96 152.93) rotate(166.26)"
}, "\xD6"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(96.12 157.01) rotate(179.07)"
}, "p"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(81.61 157.2) rotate(-167.99)"
}, "p"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(-0.92, -0.4, 0.4, -0.92, 67.45, 154.19)"
}, "n"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(-0.81, -0.58, 0.58, -0.81, 55.2, 148.92)"
}, "a"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(-0.68, -0.74, 0.74, -0.68, 43.35, 140.57)"
}, "d"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(-0.51, -0.86, 0.86, -0.51, 33.57, 129.89)"
}, "e"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(-0.39, -0.92, 0.92, -0.39, 26.81, 118.07)"
}), React.createElement("text", {
  className: "cls-1",
  transform: "translate(24.29 112.93) rotate(-104.3)"
}, "B"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(20.79 99.12) rotate(-92.63)"
}, "u"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(20.32 85.69) rotate(-83.39)"
}, "t"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(21.41 76.87) rotate(-77.29)"
}, "i"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(22.42 71.3) rotate(-69.69)"
}, "k"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(0.51, -0.86, 0.86, 0.51, 26.19, 60.63)"
}, "e"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(33.21 49.02) rotate(-50.49)"
}, "r"), React.createElement("circle", {
  cx: 47.8,
  cy: 26.95,
  r: 5.11
}), React.createElement("circle", {
  cx: 130.57,
  cy: 150.2,
  r: 5.11
})));

function SvgOpen(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 177 178.06"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "assets/open.698d433d.svg";
export { SvgOpen as ReactComponent };